<script lang="ts">
export default {
  inheritAttrs: false,
}
</script>

<script lang="ts" setup>
const lifecycleStore = useLifecycleStore()

withDefaults(
  defineProps<{
    title?: string
    description?: string
    open?: boolean
    size?: 'default' | 'tiny' | 'small' | 'large'
  }>(),
  {
    open: true,
    size: 'default',
  },
)

const emit = defineEmits<{
  (e: 'close'): void
}>()

function close(value: boolean) {
  if (value) return
  if (lifecycleStore.isSaving) return
  emit('close')
}
</script>

<template>
  <!--
    Regular Transition component doesn't work here for a combination of various reasons
    (unmounting of ancestor through vue-router, hoisting of the DOM elements to the body, ...),
    therefore we fall back to basic CSS animation to at least animate the dialog entrance.
  -->
  <RekaDialogRoot v-if="open" :open="open" @update:open="close" class="relative z-50">
    <RekaDialogOverlay
      class="fixed bottom-0 left-0 right-0 top-[var(--admin-bar-height,0px)] z-50 flex animate-fade-in items-center justify-center bg-black/20 backdrop-blur"
    />

    <div
      class="fixed bottom-2 left-2 right-2 top-[calc(var(--admin-bar-height,0px)_+_0.5rem)] z-50 flex items-center justify-center"
    >
      <RekaDialogContent
        class="relative h-full max-h-full w-full animate-grow-in overflow-auto rounded bg-white shadow-lg s:h-auto"
        :class="{
          'max-w-3xl': size === 'default',
          'max-w-2xl': size === 'small',
          'max-w-xl': size === 'tiny',
          'max-w-full s:max-w-[min(90%,_1200px)]': size === 'large',
        }"
        v-bind="$attrs"
      >
        <RekaDialogTitle v-if="title">{{ title }}</RekaDialogTitle>
        <RekaDialogDescription v-if="description">{{ description }}</RekaDialogDescription>
        <RekaDialogClose as-child>
          <Button
            v-if="!lifecycleStore.isSaving"
            theme="unstyled"
            class="absolute left-3.5 top-3.5 z-20 rounded px-2.5 py-3 text-grey-400 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-green-800 s:left-auto s:right-3.5 s:bg-none s:p-3.5"
            @click="close"
          >
            <span class="sr-only">Schliessen</span>
            <IconArrowLeft class="block s:hidden" />
            <IconX class="hidden s:block" />
          </Button>
        </RekaDialogClose>

        <slot />
      </RekaDialogContent>
    </div>
  </RekaDialogRoot>
</template>

<style lang="scss" scoped></style>
